import React from 'react';
import MetaText from "../../../../ui/Typography/texts/MetaText";
import RewardExpirationTime from '../RewardExpirationTime';
import styles from '../RewardSummary.module.scss';
const showValidity = (props) => {
    var _a, _b, _c;
    return (React.createElement(React.Fragment, null, props.isOfferActive ? (React.createElement(RewardExpirationTime, Object.assign({}, props))) : (React.createElement(MetaText, { Tag: "time", dateTime: (_a = props.dateInfoText) === null || _a === void 0 ? void 0 : _a.date, className: ((_b = props.dateInfoText) === null || _b === void 0 ? void 0 : _b.isExpired) ? styles.expireTime : styles.validTime, ellipsis: true }, (_c = props.dateInfoText) === null || _c === void 0 ? void 0 : _c.infoText))));
};
export default showValidity;
//# sourceMappingURL=showValidity.js.map